import type { IUserInput, ICalculation } from './MortgageCalculator.types';

export const calculate = (userInput: IUserInput): ICalculation => {
  const COST_OF_PLAID = 15; // cost of Plaid (mapped out of # of loan applications)
  const PLAID_VOA_CONVERSION = 0.8;
  const GSE_RW_CONVERSION = 0.25;

  // we cache this so we don't have to access the object multiple times
  const currentVoaConversionRate = userInput.currentVoAConversionRate / 100;
  const totalNumberOfApplications = userInput.annualMortgageApplications;

  // math
  const currentRwApplicants =
    totalNumberOfApplications * currentVoaConversionRate * GSE_RW_CONVERSION;
  const plaidRwApplicants =
    totalNumberOfApplications * PLAID_VOA_CONVERSION * GSE_RW_CONVERSION;
  const newRwApplicants = plaidRwApplicants - currentRwApplicants;
  const costOfNewApplicantsWithPlaid = COST_OF_PLAID * newRwApplicants;
  const costWithCompetingSolutions =
    newRwApplicants * userInput.averageVerificationCostPerApplication;
  const savingsWithPlaid =
    costWithCompetingSolutions - costOfNewApplicantsWithPlaid;

  const additionalVerifiedApplications =
    totalNumberOfApplications * PLAID_VOA_CONVERSION -
    totalNumberOfApplications * currentVoaConversionRate;

  return {
    savings: Number.isNaN(savingsWithPlaid) ? 0 : Math.floor(savingsWithPlaid),
    additionalVerifiedApplications,
  };
};
